import React from 'react';
import Control from './Control';

const Checkbox = (props) => (
  <Control {...props} type="checkbox" />
);
export default Checkbox;
